// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AchievementCelebrationController from "./achievement_celebration_controller"
application.register("achievement-celebration", AchievementCelebrationController)

import AdminBookingController from "./admin_booking_controller"
application.register("admin-booking", AdminBookingController)

import AttendanceController from "./attendance_controller"
application.register("attendance", AttendanceController)

import AnnouncementFormController from "./announcement_form_controller"
application.register("announcement-form", AnnouncementFormController)

import BillingToggleController from "./billing_toggle_controller"
application.register("billing-toggle", BillingToggleController)

import BrandingPreviewController from "./branding_preview_controller"
application.register("branding-preview", BrandingPreviewController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import CooldownController from "./cooldown_controller"
application.register("cooldown", CooldownController)

import DashboardCustomizerController from "./dashboard_customizer_controller"
application.register("dashboard-customizer", DashboardCustomizerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GenerateProgressController from "./generate_progress_controller"
application.register("generate-progress", GenerateProgressController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HelpCollapsibleController from "./help_collapsible_controller"
application.register("help-collapsible", HelpCollapsibleController)

import HelpTooltipController from "./help_tooltip_controller"
application.register("help-tooltip", HelpTooltipController)

import LandingPageCustomizerController from "./landing_page_customizer_controller"
application.register("landing-page-customizer", LandingPageCustomizerController)

import LandingPageDebugController from "./landing_page_debug_controller"
application.register("landing-page-debug", LandingPageDebugController)

import PaymentFinalizerController from "./payment_finalizer_controller"
application.register("payment-finalizer", PaymentFinalizerController)

import IntlPhoneController from "./intl_phone_controller"
application.register("intl-phone", IntlPhoneController)

import LandingPageFormController from "./landing_page_form_controller"
application.register("landing-page-form", LandingPageFormController)

import AiContentController from "./ai_content_controller"
application.register("ai-content", AiContentController)

import AutomationFormController from "./automation_form_controller"
application.register("automation-form", AutomationFormController)

import LeadsKanbanController from "./leads_kanban_controller"
application.register("leads-kanban", LeadsKanbanController)

import LocationSelectorController from "./location_selector_controller"
application.register("location-selector", LocationSelectorController)

import ManualPurchaseController from "./manual_purchase_controller"
application.register("manual-purchase", ManualPurchaseController)

import MercadopagoCheckoutController from "./mercadopago_checkout_controller"
application.register("mercadopago-checkout", MercadopagoCheckoutController)

import MemberOnboardingController from "./member_onboarding_controller"
application.register("member-onboarding", MemberOnboardingController)

import MembershipPlanFormController from "./membership_plan_form_controller"
application.register("membership-plan-form", MembershipPlanFormController)

import MigrationProgressController from "./migration_progress_controller"
application.register("migration-progress", MigrationProgressController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import OnboardingChecklistController from "./onboarding_checklist_controller"
application.register("onboarding-checklist", OnboardingChecklistController)

import OperatingHoursController from "./operating_hours_controller"
application.register("operating-hours", OperatingHoursController)

import OrganizationSessionFormController from "./organization_session_form_controller"
application.register("organization-session-form", OrganizationSessionFormController)

import PaymentGatewaySelectorController from "./payment_gateway_selector_controller"
application.register("payment-gateway-selector", PaymentGatewaySelectorController)

import PaymentMethodSelectorController from "./payment_method_selector_controller"
application.register("payment-method-selector", PaymentMethodSelectorController)

import PaymentMethodsController from "./payment_methods_controller"
application.register("payment-methods", PaymentMethodsController)

import PaymentSetupController from "./payment_setup_controller"
application.register("payment-setup", PaymentSetupController)

import PlatformStripeConfigController from "./platform_stripe_config_controller"
application.register("platform-stripe-config", PlatformStripeConfigController)

import PlanCalculatorController from "./plan_calculator_controller"
application.register("plan-calculator", PlanCalculatorController)

import PurchaseOtpController from "./purchase_otp_controller"
application.register("purchase-otp", PurchaseOtpController)

import RoomSelectorController from "./room_selector_controller"
application.register("room-selector", RoomSelectorController)

import ScheduleAvailabilityController from "./schedule_availability_controller"
application.register("schedule-availability", ScheduleAvailabilityController)

import SeatLayoutBuilderController from "./seat_layout_builder_controller"
application.register("seat-layout-builder", SeatLayoutBuilderController)

import SeatSelectorController from "./seat_selector_controller"
application.register("seat-selector", SeatSelectorController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import StripeCheckoutController from "./stripe_checkout_controller"
application.register("stripe-checkout", StripeCheckoutController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TopicSelectorController from "./topic_selector_controller"
application.register("topic-selector", TopicSelectorController)

import TutorialController from "./tutorial_controller"
application.register("tutorial", TutorialController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DatetimepickerController from "./datetimepicker_controller"
application.register("datetimepicker", DatetimepickerController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)
